import { configDingTalk } from "@/service/appList";
export default {
  name: "AppDetailTab2",
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      }
    },
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      yypzConfig: [{
        title: "appKey",
        key: "appKey",
        rules: [{
          required: true,
          message: $t("k2zv508", "AppKey必填"),
          trigger: "blur,change"
        }]
      }, {
        title: "appSecret",
        key: "appSecret",
        rules: [{
          required: true,
          message: $t("ff5bzdb", "AppSecret必填"),
          trigger: "blur,change"
        }]
      }]
    };
  },
  computed: {
    _unitId() {
      return this.$store.state.user.userInfo.unitId;
    }
  },
  methods: {
    /*
     * 保存
     */
    async yypzChange() {
      this.$refs.yypz.validate(async val => {
        if (val) {
          const {
            appKey,
            appSecret
          } = this.detail;
          const res = await configDingTalk({
            appId: this.item.id,
            unitId: this._unitId,
            appKey,
            appSecret
          });
          if (res.data && res.data.result == 0) {
            this.$Message.success(res.data.msg);
          }
        }
      });
    }
  }
};